<div
  class="dashboard__container"
  [ngClass]="{'no-scroll': dashboardExtended}"
  fixedWidth
  ref="campaign-display"
  >
  <div
    class="dashboard-area"
    [ngClass]="{'extra__row': showExtendedSearchFilters}"
  >
    <div
      class="filters clearfix show-filter inner-block small clearfix shadow-z-1"
      [ngClass]="{'extra__row': showExtendedSearchFilters}"
      >
      <div class="content clearfix">
        <div class="dashboard__container" fixedWidth ref="campaign-display">
          <div class="row margin-right--3x">
            <div class="col-md-12 col-lg-6 col-xl-4 padding-right--none">
              <div class="relative">
                <div class="search--box">
                  @if(search.searchText !== '' && search.searchActive) {
                  <span
                    (click)="resetSearchText()"
                    class="icon-close-x"
                    ></span>
                  }
                  <div class="input__container">
                    <a tabindex="-1" wooFocus="!dashboardExtended"></a>
                    <label for="searchQuery">Sök</label>
                    <input
                      id="searchQuery"
                      type="text"
                      [(ngModel)]="search.searchText"
                      name="searchText"
                      tabindex="400"
                      (keydown.enter)="filterCampaigns()"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-lg-6 col-xl-2 padding-right--none">
              @if(customers.length) {
              <woo-customer-dropdown
                [items]="customers"
                [(ngModel)]="search.customer"
                name="customer-search"
                inputId="customer-search"
                labelText="Kund"
                [searchAttributes]="['name', 'nickname']"
                notFoundText="Inga kunder hittades."
                [clearable]="true"
                [labelCreate]="showCustomerNickname"
              ></woo-customer-dropdown>
              }
            </div>
            <div class="col-sm-6 col-lg-6 col-xl-3 padding-right--none">
              <button
              id="more-search-options"
              class="status-badge inverse"
              (click)="showExtendedSearchFilters = !showExtendedSearchFilters"
              type="button"
              tabindex="420"
              >
                <div class="hover-text hover--below">Fler sökmöjligheter</div>
                @if(!showExtendedSearchFilters) {
                  <span class="icon-TV4_013_filter"></span>
                } @else {
                  <span class="icon-close-x"></span>
                }
              </button>

              <button
                id="search-info-button"
                class="status-badge inverse margin-left--half-1x"
                type="button"
                (click)="openSearchInfo()"
                tabindex="440"
              >
                <div class="hover-text hover--below">Sökinformation</div>
                <span class="icon-info-outline"></span>
              </button>
              <button
                id="search-button"
                class="button primary-1 min-width--auto search_button"
                tabindex="430"
                (click)="filterCampaigns()">
                Sök
              </button>
            </div>
            <div class="col-sm-6 col-lg-6 col-xl-3 padding--none">
              <div class="float-end margin-left--4x">
                <button
                class="status-badge inverse active"
                (click)="setCardListing()"
                tabindex="450"
                >
                  <div class="hover-text hover--below">Ändra listvy</div>
                  @if(!cardListing) {
                    <span class="icon-thumbnails-grid"></span>
                  } @else {
                    <span class="icon-menu"></span>
                  }
                </button>
                @if(allowedToBook && totalCampaigns) {
                  <create-campaign-from-template-button
                    class="margin-left--half-1x"
                    [customersForUser]="customersForUser"
                    tabindex="460"
                  ></create-campaign-from-template-button>
                }
                @if(allowedToBook) {
                  <button
                    (click)="goToNewCampaign()"
                    class="status-badge primary margin-left--half-1x"
                    tabindex="470"
                    id="new-campaign-btn"
                  >
                    <div class="hover-text hover--below">Ny kampanj</div>
                    <span class="icon-plus"></span>
                  </button>
                }
              </div>
            </div>
          </div>

          @if(showExtendedSearchFilters) {
          <div class="row margin-right--3x">
            <div class="col-sm-4 col-lg-3 col-xl-2 padding-right--none">
              <div class="input__container">
                <woo-dropdown
                  [items]="searchDateTypes"
                  [(ngModel)]="search.dateType"
                  bindLabel="name"
                  inputId="date-type-select"
                  labelText="Datumtyp"
                  [searchAttributes]="['name']"
                ></woo-dropdown>
              </div>
            </div>

            <div class="col-sm-4 col-lg-3 col-xl-2 padding-right--none">
              <div class="input__container">
                <label for="fromDate">Startdatum</label>
                <input id="fromDate" type="date" [(ngModel)]="search.from" />
              </div>
            </div>
            <div class="col-sm-4 col-lg-3 col-xl-2 padding-right--none">
              <div class="input__container">
                <label for="toDate">Slutdatum</label>
                <input id="toDate" type="date" [(ngModel)]="search.to" />
              </div>
            </div>
            @if(!isLoading.organisations && maySearchOrganisation) {
              <div class="col-sm-4 col-lg-3 col-xl-2 padding-right--none">
                <woo-dropdown
                  [items]="filterAdOrganisations"
                  [(ngModel)]="search.adOrganisation"
                  bindLabel="name"
                  inputId="adorgansation-search"
                  labelText="Organisation"
                  [searchAttributes]="['name']"
                ></woo-dropdown>
              </div>
            }
            @if(maySeeClosedCampaigns) {
              <div class="col-sm-4">
                <div class="relative margin-top--3x margin-left--2x">
                  <input
                    id="includeClosed"
                    type="checkbox"
                    class="checkbox"
                    [(ngModel)]="search.includeClosed"
                  />
                  <label for="includeClosed" class="checkbox"
                    >Inkl. stängda kampanjer</label
                  >
                </div>
              </div>
            }
          </div>
          }
        </div>
      </div>
    </div>

    <div
      class="dashboard dashboard--block"
      [ngClass]="{'list': !cardListing, 'padding-top--4x': showExtendedSearchFilters}"
    >
      <dashboard-campaigns [cardListing]="cardListing" [totalCampaigns]="totalCampaigns"></dashboard-campaigns>
    </div>
  </div>

  <div
    class="campaign-display narrow"
    [ngClass]="{'narrow': activeCampaign !== null, 'take-over': dashboardExtended }"
    >
    <div class="command-panel">
      @if(activeCampaign !== null){
      <button
        id="openCampaign"
        class="vertical-align no-outline"
        (click)="toggleExtended()"
      >
        <span class="command-button circle" [ngClass]="{'rotate': dashboardExtended}"  >
          <span class="icon icon-TV4_009_bak"></span>
        </span>
      </button>
      }
    </div>
    <div class="campaign-details relative">
      <dashboard-sidebar></dashboard-sidebar>
    </div>
    <div class="campaign-info">
      <follow-up class="follow-up"></follow-up>
    </div>
  </div>
</div>
